const datas = [
  {
    number: "10M+",
    description: "Partner Customer Reach",
  },
  {
    number: "2,000+",
    description: "Retail & Online Merchant Access",
  },
  {
    number: "500K+",
    description: "Real-World Inventory Connections",
  },
];

export default function Section2() {
  return (
    <section id="section2" className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex flex-1 flex-col items-start">
            <h2 className="text-[38px] md:text-[38px] lg:text-[38px] font-normal text-white mb-6 tracking-tight max-w-xs">
              A network powered by real partnerships
            </h2>
            <p className="text-[18px] text-white mb-[70ox] tracking-tight max-w-xs">
              From publicly listed companies to major content studios,Switch is
              building a real-world commerce network backed by verified partners
            </p>
          </div>
          <div className="flex flex-1 flex-col gap-16">
            {datas.map((data) => (
              <div className="flex flex-col">
                <h3 className="text-[100px] md:text-[100px] lg:text-[100px] font-normal leading-none tracking-tight bg-gradient-to-bl from-white to-white/40 bg-clip-text text-transparent">
                  {data.number}
                </h3>
                <p className="text-[12px] md:text-[16px] lg:text-[16px] text-[#c4c4c4] tracking-tight">
                  {data.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
